var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.geometrias.length > 0)?_c('div',{staticClass:"fill-width",style:(_vm.customMapa),attrs:{"id":"map"}}):_c('div',{staticClass:"empty"},[_vm._v("Não há vetorização para ser exibida.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }